<style>
    mRegister {
        position:relative;
    }
    #mRegister img {
        border: none;
    }
    #mRegister .ivu-modal-header {
        border-bottom: 0 solid;
    }
    #mRegister .ivu-modal-footer {
        border-top: 0 solid;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
    }
    #mRegister .ivu-modal-content {
        height: 97vh;
    }
    #mRegister .title-question {
        color: #a1a1a1;
        position: relative;
        font-size: 1.2em;
    }
    #mRegister .title-question:after {
        content: ' ';
        height: 1px;
        width: 50px;
        background: #ddd;
        position: absolute;
        left: 43%;
        bottom: -10px;
    }
    #mRegister .ivu-auto-complete.ivu-select-dropdown {
        max-height: 30vh;
    }
    #mRegister .scrolling-section {
        height: 75vh;
        overflow:hidden;
        overflow-y:auto;
    }
</style>

<template>
    <div class="profile-onboarding-tls">
        <Modal id="mRegister" :scrollable="false" v-model="showOnBoarding" :styles="{top: '0', height: '100vh'}" :mask-closable="false" :closable="false">
            <p slot="header" style="font-size:1.3em">
                <span style="float:right" v-if="page > 0 && page < 6">
                    <Icon v-for="(n,indx) in 5" :key="n" size="10" style="margin-left:5px" :type="(indx + 1 <= page) ? 'ios-circle-filled':'ios-circle-outline'"></Icon>
                </span>
                {{pageName}}
            </p>
            <div class="initial" v-if="page == 0">
                <h3 align="center" class="title-question">Welcome Kababayan!</h3>
                <img alt=" " src="~@/assets/logo.png" width="50%" style="display:block;margin:20px auto"/>
                <p style="margin-bottom:20px;font-size: 1.3em;padding:0 20px;line-height:1.5em" align="center">A global social network empowering OFWs to help themselves, each other and the government agencies tasked with supporting them.</p>
            </div>
            <div class="step-1 scrolling-section" v-if="page == 1">
                <h3 align="center" class="title-question">Please select you gender.</h3>
                <Row type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="17" style="text-align:center">
                        <p align="center" @click="profile.gender='male';loadAvatars(profile.gender)" style="position:relative;width:80px;display:inline-block">
                            <span style="display:block;margin:0 auto 10px">
                                <img alt=" " src="~@/assets/004-user.png" width="40" height="40"/>
                                <Icon v-if="profile.gender === 'male'" type="ios-checkmark" size="20" style="position:absolute;top:20px;margin-left:-7px;color:#2d8cf0"></Icon>
                            </span>
                            MALE
                        </p>
                        <p align="center" @click="profile.gender='female';loadAvatars(profile.gender)" style="position:relative;width:80px;display:inline-block">
                            <span style="display:block;margin:0 auto 10px">
                                <img alt=" " src="~@/assets/003-user-1.png" width="40" height="40"/>
                                <Icon v-if="profile.gender === 'female'" type="ios-checkmark" size="20" style="position:absolute;top:20px;margin-left:-7px;color:#2d8cf0"></Icon>
                            </span>
                            FEMALE
                        </p>
                    </Col>
                </Row>
                <h3 v-if="profile.gender" align="center" class="title-question">Set your profile picture.</h3>
                <Row v-if="profile.gender" type="flex" justify="center" :gutter="15" style="position:relative;margin-top:35px;margin-bottom:25px;">
                    <Col :span="24">
                        <span style="display:block;margin:0 auto 10px;text-align:center;position:relative;width:120px;">
                            <img alt=" " :src="other.avatar" style="width:120px;height:120px;overflow:hidden;border-radius:100%;border:5px solid #ddd" width="120" height="120"/>
                            <span style="background:#000;height:40px;width:40px;position:absolute;border-radius:100px;left:0;bottom:0">
                                <Upload
                                    :show-upload-list="false"
                                    ref="upload"
                                    :on-success="handleSuccess"
                                    :format="['jpg','jpeg','png']"
                                    :max-size="6144"
                                    :action="uploadUrl"
                                    name="photo[]"
                                    style="display: inline-block;width:40px;">
                                    <div style="border-radius:100%;width:40px;background:#ddd;line-height: 20px;">
                                        <img alt=" " style="filter: invert(0);margin-top: 10px;margin-right: -3px;" src="~@/assets/001-photo.png" width="25" height="25"/>
                                    </div>
                                </Upload>
                            </span>
                        </span>
                    </Col>
                    <Col :span="24" style="text-align:center;overflow:hidden;overflow-x:auto;width:100%;height:175px">
                        <div style="height:175px;width:170%;text-align:left">
                            <span style="margin:0 2px;padding:3px;display:inline-block" v-for="(n, k, kIndex) in avatars" :key="k" @click="setAvatar(profile.gender, n)">
                                <img alt=" " style="border-radius:100%;" :src="baseUrl + profile.gender + '/' + n" width="50" height="50"/>
                            </span>
                        </div>
                    </Col>
                </Row>
            </div>
            <div class="step-2 scrolling-section" v-if="page == 2">
                <h3 align="center" class="title-question">Are you originally from the Philippines?</h3>
                <Row type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="16" style="text-align:center">
                        <p align="center" @click="other.isPH=true" style="position:relative;width:80px;display:inline-block">
                            <span style="display:block;margin:0 auto 10px">
                                <img alt=" " src="~@/assets/002-like.png" width="40" height="40"/>
                                <Icon v-if="other.isPH" type="ios-checkmark" size="20" style="position:absolute;top:20px;margin-left:-7px;color:#2d8cf0"></Icon>
                            </span>
                            YES
                        </p>
                        <p align="center" @click="other.isPH=false" style="position:relative;width:80px;display:inline-block">
                            <span style="display:block;margin:0 auto 10px">
                                <img alt=" " src="~@/assets/005-hands.png" width="40" height="40"/>
                                <Icon v-if="other.isPH == false" type="ios-checkmark" size="20" style="position:absolute;top:20px;margin-left:-7px;color:#2d8cf0"></Icon>
                            </span>
                            NO
                        </p>
                    </Col>
                </Row>
                <h3 v-if="other.isPH != null && other.isPH != false" align="center" class="title-question">What's your dialect?</h3>
                <Row v-if="other.isPH != null && other.isPH != false" type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="22">
                        <Select size="large" v-model="profile.dialect" filterable>
                            <Option v-for="(item,k) in dialects" :value="item.name" :key="k">{{ item.name }}</Option>
                        </Select>
                    </Col>
                </Row>
                <h3 v-if="profile.dialect" align="center" class="title-question">Set your Region, City & Dialect.</h3>
                <Row v-if="profile.dialect" type="flex" justify="center" :gutter="15" style="margin-top:10px;margin-bottom:20px;">
                    <Col :span="22">
                        <div v-if="other.isPH">
                            <div>
                                <p style="margin:10px 0">Region</p>
                                <Select size="large" v-model="profile.origin.region" filterable>
                                    <Option v-for="(item,k) in regionlist" :value="item.region_name" :key="k">{{ item.region_name }}</Option>
                                </Select>
                            </div>
                            <div style="margin-top:15px" v-if="profile.origin.region">
                                <p style="margin-bottom:10px">City</p>
                                <AutoComplete style="display:block" icon="ios-search" size="large" placeholder="Name of the city" v-model="originSearchCity" @on-select="onSelectOriginCity(originSearchCity)" @on-search="getCityProvinceSearch(originSearchCity)">
                                    <Option v-for="(item,k) in searchCity.cities" @click="onSelectOriginCity(originSearchCity)"
                                        :value="item.name" :key="k">
                                        <span v-if="item.name">{{ item.name }}, </span>
                                        <span v-if="item.province.province_name">{{item.province.province_name}}, </span>
                                        <span v-if="item.province.region.region_name">{{item.province.region.region_name}}</span>
                                    </Option>
                                </AutoComplete>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div class="step-4 scrolling-section" v-show="page == 3" style="padding-top:25vh">
                <h3 align="center" class="title-question">Which of the following is the best describe your situation?.</h3>
                <Row type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="22">
                        <div>
                            <Select size="large" v-model="profile.status" filterable>
                                <Option v-for="item in statuses" v-if="isVisibleStatus(other.isPH, item)" :value="item.name" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </Col>
                </Row>
            </div>
            <div class="step-5 scrolling-section" v-show="page == 4 && profile.status && profile.status !== 'Family Member'" style="padding-top:10vh">
                <h3 align="center" class="title-question">What's your occupation?</h3>
                <Row type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="22">
                        <div>
                            <Select size="large" v-model="profile.occupation" filterable>
                                <Option v-for="(item,k) in occupations" :value="item.name" :key="k">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </Col>
                </Row>
                <h3 v-if="profile.status !== 'Seaman' && profile.status !== 'Applicant' && profile.occupation" align="center" class="title-question">Where are you working?</h3>
                <Row v-if="profile.status !== 'Seaman' && profile.status !== 'Applicant' && profile.occupation" type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="22">
                        <div>
                            <p style="margin-bottom:10px">Country</p>
                            <Select size="large" v-model="profile.country" filterable>
                                <Option v-for="(item,i) in countries" :value="item.name" :key="i">{{ item.name }}</Option>
                            </Select>
                        </div>
                        <div style="margin-top:15px">
                            <p style="margin-bottom:10px">City</p>
                            <AutoComplete style="display:block" size="large" placeholder="Name of the city" v-model="originSearchOverseasCity" @on-select="onSelectOverseasCity(originSearchOverseasCity)" @on-search="getCitySearch(originSearchOverseasCity)">
                                <Option v-for="(item,k) in searchOverseasCity.cities" :value="item.name" :key="k">
                                    <span v-if="item.name">{{ item.name }}, </span>
                                    <span v-if="item.province.province_name">{{item.province.province_name}}, </span>
                                    <span v-if="item.province.region.region_name">{{item.province.region.region_name}}</span>
                                </Option>
                            </AutoComplete>
                        </div>
                    </Col>
                </Row>
            </div>
            <div class="step-5 scrolling-section" v-show="page == 4 && profile.status && profile.status === 'Family Member'" style="height:75vh;overflow:hidden;overflow-y:auto">
                <h3 align="center" class="title-question">What's your relative's occupation?</h3>
                <Row type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="22">
                        <div>
                            <Select size="large" v-model="profile.occupation" filterable>
                                <Option v-for="item in occupations" :value="item.name" :key="item.value">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </Col>
                </Row>
                <h3 v-if="profile.occupation" align="center" class="title-question">What's your relation to the OFW?</h3>
                <Row v-if="profile.occupation" type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="22">
                        <div>
                            <Select size="large" v-model="profile.relationship" filterable>
                                <Option v-for="item in relationshit" :value="item.name" :key="item.value">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </Col>
                </Row>
                <h3 v-if="profile.relationship" align="center" class="title-question">Where is your relative working?</h3>
                <Row v-if="profile.relationship" type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="22">
                        <div>
                            <p style="margin-bottom:10px">Country</p>
                            <Select size="large" v-model="profile.country" filterable>
                                <Option v-for="(item,i) in countries" :value="item.name" :key="i">{{ item.name }}</Option>
                            </Select>
                        </div>
                        <div style="margin-top:15px">
                            <p style="margin-bottom:10px">City</p>
                            <AutoComplete style="display:block" size="large"
                                icon="ios-search"
                                placeholder="Name of the city"
                                v-model="originSearchOverseasCity"
                                @on-select="onSelectOverseasCity(originSearchOverseasCity)"
                                @on-search="getCitySearch(originSearchOverseasCity)">
                                <Option v-for="(item,k) in searchOverseasCity.cities" :value="item.name" :key="k">
                                    <span v-if="item.name">{{ item.name }}, </span>
                                    <span v-if="item.province.province_name">{{item.province.province_name}}, </span>
                                    <span v-if="item.province.region.region_name">{{item.province.region.region_name}}</span>
                                </Option>
                            </AutoComplete>
                        </div>

                    </Col>
                </Row>
            </div>
            <div class="step-6 scrolling-section" v-if="page == 5" style="padding-top:30vh">
                <h3 align="center" class="title-question">Do you want to be alerted when an OFW near you is in trouble?</h3>
                <Row type="flex" justify="center" :gutter="15" style="margin-top:30px;margin-bottom:20px;">
                    <Col :span="17" style="text-align:center">
                        <p align="center" @click="profile.alert=true" style="position:relative;width:100px;display:inline-block">
                            <span style="display:block;margin:0 auto 10px">
                                <img alt=" " src="~@/assets/002-like.png" width="40" height="40"/>
                                <Icon v-if="profile.alert" type="ios-checkmark" size="20" style="position:absolute;top:20px;margin-left:-7px;color:#2d8cf0"></Icon>
                            </span>
                            YES
                        </p>
                        <p align="center" @click="profile.alert=false" style="position:relative;width:100px;display:inline-block">
                            <span style="display:block;margin:0 auto 10px">
                                <img alt=" " src="~@/assets/005-hands.png" width="40" height="40"/>
                                <Icon v-if="profile.alert == false" type="ios-checkmark" size="20" style="position:absolute;top:20px;margin-left:-7px;color:#2d8cf0"></Icon>
                            </span>
                            NO
                        </p>
                    </Col>
                </Row>
            </div>
            <div class="final" v-if="page == 6" style="padding-top:20vh">
                <h3 align="center" class="title-question">Success, Your all set!</h3>
                <div style="text-align:center;margin: 25px 0">
                    <Icon type="ios-checkmark" size="150" style="color:#2d8cf0"></Icon>
                </div>
            </div>
            <div slot="footer">
                <Button size="large" type="primary" @click="nextPage()" :disabled="setDisabled()">{{btnTxt}}</Button>
                <span style="float:left;" v-if="page > 0 && page <= 7">
                    <Button size="large" type="text" @click="prevPage()">Back</Button>
                </span>
            </div>
        </Modal>
    </div>
</template>

<script>
import relationsJson from '@/assets/relation.json'
import statusJson from '@/assets/status.json'
import relations2Json from '@/assets/refregion_detailed.json'
import dialectsJson from '@/assets/dialects.json'
import occupationsJson from '@/assets/occupations.json'
import countriesJson from '@/assets/countries.json'

import axios from 'axios'
import _ from 'lodash'

export default {
  name: 'ProfileOnBoardingComponent',
  computed: {
    'showOnBoarding': {
      get () {
        return this.$store.state.user.showOnboardingModal
      }
    },
    uploadUrl() {
      return process.env.VUE_APP_API  + 'uploadphoto';
    }
  },
  mounted () {
    this.relationshit = relationsJson
    this.statuses = statusJson
    this.regionlist = relations2Json
    this.dialects = dialectsJson
    this.occupations = occupationsJson
    this.countries = countriesJson
  },
  methods: {
    setAvatar (g, n) {
      if (g == 'male') { this.other.avatar = this.baseUrl + 'male/' + n } else if (g == 'female') { this.other.avatar = this.baseUrl + 'female/' + n } else { this.other.avatar = TEMP_URL + n }
    },
    loadAvatars (gender) {
      var url = '//api.ofwwatch.com/v3.4/image/libraries'

      axios.get(url).then(res => {
        this.baseUrl = res.data.base_url

        if (gender === 'female') {
          this.avatars = res.data.images.female
          this.other.avatar = this.baseUrl + 'female/' + res.data.images.female[0]
        } else if (gender === 'male') {
          this.avatars = res.data.images.male
          this.other.avatar = this.baseUrl + 'male/' + res.data.images.male[0]
        }
      })
    },
    handleView (name) {
      this.imgName = name
      this.visible = true
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    handleSuccess (res, file) {
      this.setAvatar(null, file.response.uploaded[0])
    },
    onSelectOriginCity (value) {
      for (var x = 0; x < this.searchCity.cities.length; x++) {
        if (value === this.searchCity.cities[x].name) {
          this.$set(this.profile.origin, 'city', this.searchCity.cities[x].name)
          this.$set(this.profile.origin, 'province', this.searchCity.cities[x].province.province_name)
          this.$set(this.profile.origin, 'region', this.searchCity.cities[x].province.region.region_name)
          this.$set(this.profile.origin, 'country', this.searchCity.cities[x].province.region.country.country_name)
        }
      }
    },
    onSelectOverseasCity (value) {
      for (var x = 0; x < this.searchOverseasCity.cities.length; x++) {
        if (value === this.searchOverseasCity.cities[x].name) {
          this.$set(this.profile, 'city', this.searchOverseasCity.cities[x].name)
          this.$set(this.profile, 'province', this.searchOverseasCity.cities[x].province.province_name)
          this.$set(this.profile, 'region', this.searchOverseasCity.cities[x].province.region.region_name)
          this.$set(this.profile, 'country', this.searchOverseasCity.cities[x].province.region.country.country_name)
        }
      }
    },
    getCitySearch (str) {
      let url = '//api.ofwwatch.com/v3.4/cities'
      if (str != null && str) { url += '?search=' + str }
      axios.get(url)
        .then(res => {
          this.searchOverseasCity = res.data
        }, error => {})
    },
    getCityProvinceSearch (str, regCode) {
      var url = '//api.ofwwatch.com/v3.4/cities'
      var regCode = null
      for (var i = 0; i < this.regionlist.length; i++) {
        if (this.regionlist[i].region_name === this.profile.origin.region) {
          regCode = this.regionlist[i].region_code
          break
        }
      }

      if (str != null && str) { url += '?search=' + str }

      if (this.other.isPH && str && this.profile.origin.region) { url += '&country_code=ph&region_code=' + regCode } else if (this.other.isPH && !str && this.profile.origin.region) { url += '?country_code=ph&region_code=' + regCode } else if (this.other.isPH && !str) { url += '?country_code=ph' }

      axios.get(url)
        .then(res => {
          this.searchCity = res.data
        }, error => {})
    },
    prevPage () {
      this.page -= 1
      this.pageBtnSetter()
    },
    nextPage () {
      if (this.page == 6) {
        this.saveOnBoarding()
        return false
      }

      this.page += 1
      this.pageBtnSetter()

      if (this.page == 2) {
        this.getCityProvinceSearch()
        this.originSearchCity = null
        this.$set(this.other, 'isPH', null)
        this.$set(this.profile.origin, 'city', null)
        this.$set(this.profile.origin, 'province', null)
        this.$set(this.profile.origin, 'region', null)
        this.$set(this.profile.origin, 'country', null)
        this.$set(this.profile, 'dialect', null)
      }

      if (this.page == 4) {
        this.getCitySearch()
        this.originSearchOverseasCity = null
        this.$set(this.profile, 'occupation', null)
        this.$set(this.profile, 'relationship', null)
        this.$set(this.profile, 'city', null)
        this.$set(this.profile, 'province', null)
        this.$set(this.profile, 'region', null)
        this.$set(this.profile, 'country', null)
      }
    },
    setDisabled () {
      if (this.page === 1 && !this.profile.gender) { return true }
      if (this.page === 2 && this.other.isPH == null && !this.profile.origin.city) { return true }
      if (this.page === 3 && !this.profile.status) { return true }
      if (this.page === 4) {
        if (this.profile.status != 'applicant' && this.profile.status != 'seaman') { return false } else if (!this.profile.city && !this.profile.country) { return true }
      }

      return false
    },
    pageBtnSetter () {
      if (this.page >= 1 && this.page <= 4) {
        this.pageName = 'Step ' + this.page
        this.btnTxt = 'Next'
      } else if (this.page == 5) {
        this.pageName = 'Volunteer'
        this.btnTxt = 'Next'
      } else if (this.page >= 6) {
        this.pageName = ''
        this.btnTxt = 'Done'
      } else if (this.page <= 0) {
        this.pageName = ''
        this.btnTxt = 'Get Started'
      }
    },
    isVisibleStatus (ph, item) {
      if (ph && item.name === 'Expat') return false
      if (!ph && item.name !== 'Expat' && item.name !== 'Other') return false
      return true
    },
    saveOnBoarding () {
      var data = {
        'profile': this.profile,
        'other': this.other,
        'id': this.$store.state.user.info.id
      }

      data.profile.city = this.originSearchOverseasCity
      data.profile.origin.city = this.originSearchCity

      this.$store.dispatch('user/saveOnboardingData', {data})
        .then(res => {
          this.$store.commit('user/showOnboardingModal', false)
        })
    }
  },
  data () {
    return {
      btnTxt: 'Get Started',
      pageName: '',
      page: 0,
      originSearchCity: null,
      originSearchOverseasCity: null,
      regionlist: [],
      relationshit: [],
      dialects: [],
      countries: [],
      occupations: [],
      statuses: [],
      searchCity: [],
      searchOverseasCity: [],
      avatars: [],
      baseUrl: '',
      other: {
        isPH: null,
        avatar: ''
      },
      profile: {
        origin: {
          country: null,
          region: null,
          province: null,
          city: null
        },
        alert: true,
        status: null,
        occupation: null,
        gender: null,
        region: null,
        city: null,
        dialect: null,
        province: null,
        country: null,
        relationship: null
      },
      imgName: '',
      visible: false
    }
  }
}
</script>
